import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';

// Création du Contexte
const ThemeContext = createContext();

// Hook personnalisé pour l'utilisation simplifiée
export const useTheme = () => {
    return useContext(ThemeContext);
};

// Provider du Contexte
export const ThemeProvider = ({ children }) => {
    // État local pour le thème, avec une valeur par défaut lue depuis le localStorage
    // 'blue' sera le thème par défaut si rien n'est stocké
    const [currentTheme, setCurrentTheme] = useState(() => {
        return localStorage.getItem('appTheme') || 'blue';
    });

    // Effet pour mettre à jour le localStorage chaque fois que le thème change
    useEffect(() => {
        localStorage.setItem('appTheme', currentTheme);
    }, [currentTheme]);

    // Fonction pour changer le thème
    const toggleTheme = (theme) => {
        setCurrentTheme(theme);
    };
    
    // Valeur fournie par le Contexte
    const value = useMemo(() => ({
        currentTheme,
        toggleTheme,
    }), [currentTheme]);

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};

// Export par défaut (optionnel mais parfois utile)
export default ThemeProvider;